import { useState } from "react";
import { BsUpload } from "react-icons/bs";
import { MdDelete } from "react-icons/md";
import {
  Button,
  CustomInput,
  IconButton,
  Modal,
  Table,
  Text,
} from "../../../../component/common";
import SwitchComp from "../../../../component/Switch";
import { cn } from "../../../../utils/lib";
import { ResumeProps } from "../CandidateList";
const nodata = require("../../../../assets/images/nodata.png");

interface UploadCandidateResumeProps {
  uploadResumeModal: boolean;
  setUploadResumeModal: (uploadResumeModal: boolean) => void;
  resumes: ResumeProps[];
  setResumes: any;
  resumeType: boolean[];
  setResumeType: (resumeType: boolean[]) => void;
  fileError: string;
  uploadResume: () => void;
  selectedFile: File[];
  handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  removeResume: (index: number) => void;
  addresumes: () => void;
  isDisabled?: boolean;
}

const UploadCandidateResume = ({
  uploadResumeModal,
  setUploadResumeModal,
  resumes,
  setResumes,
  resumeType,
  setResumeType,
  fileError,
  uploadResume,
  selectedFile,
  handleImageChange,
  removeResume,
  addresumes,
}: UploadCandidateResumeProps) => {
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [uploadStep, setUploadStep] = useState<boolean>(false);

  const handleInputChange = (index: number, field: string, value: string) => {
    setResumes((prevItems: ResumeProps[]) =>
      prevItems.map((item: ResumeProps, ind: number) =>
        ind === index ? { ...item, [field]: value } : item
      )
    );
  };

  const handleError = (index: number, field: string, value: string) => {
    let errorMessage = "";
    if (value !== "" && !isNaN(Number(value)) && value.length !== 4) {
      errorMessage = "Must have 4 digits";
    }

    setResumes((prevItems: ResumeProps[]) =>
      prevItems.map((item: ResumeProps, ind: number) =>
        ind === index ? { ...item, [`${field}_error`]: errorMessage } : item
      )
    );
  };

  const getTableDetails = () => {
    const columns = [
      { label: "First Name", accessor: "first_name" },
      // { label: "Last Name", accessor: "last_name" },
      { label: "Email", accessor: "email" },
      { label: "Mobile", accessor: "mobile" },
      // { label: "Aadhar", accessor: "aadhar" },
      // { label: "SSN", accessor: "ssn" },
      { label: "Type", accessor: "type" },
      { label: "Matching", accessor: "matching" },
      { label: "Action", accessor: "action" },
    ];

    const data = resumes.map((res: any, index: number) => ({
      first_name:
        editIndex !== index ? (
          <Text className="truncate w-[115px]" text={res?.name || "-"} />
        ) : (
          <CustomInput
            placeholder="First Name"
            type="text"
            name="name"
            className="min-w-[100px]"
            value={res?.name}
            onChange={(event: any) => {
              handleInputChange(index, "name", event.target.value);
            }}
          />
        ),
      last_name:
        editIndex !== index ? (
          <Text text={res?.last_name || "-"} />
        ) : (
          <CustomInput
            placeholder="Last Name"
            type="text"
            name="last_name"
            className="min-w-[100px]"
            value={res?.last_name}
            onChange={(event: any) => {
              handleInputChange(index, "last_name", event.target.value);
            }}
          />
        ),
      email:
        editIndex !== index ? (
          <Text className="truncate max-w-44" text={res?.email || "-"} />
        ) : (
          <CustomInput
            placeholder="Email ID"
            type="text"
            name="email"
            className={`min-w-[100px] ${
              res?.email_error ? "border-red-500" : ""
            }`}
            value={res?.email}
            onChange={(event: any) => {
              handleInputChange(index, "email", event.target.value);
            }}
            isError={res?.email_error}
          />
        ),
      mobile:
        editIndex !== index ? (
          <Text text={res?.mobile || "-"} />
        ) : (
          <CustomInput
            placeholder="Contact Number"
            type="text"
            name="mobile"
            className="min-w-[100px]"
            value={res?.mobile}
            onChange={(event: any) => {
              handleInputChange(index, "mobile", event.target.value);
            }}
          />
        ),
      aadhar:
        editIndex !== index ? (
          <Text text={res?.aadhar || "-"} />
        ) : (
          <div>
            <CustomInput
              placeholder="Last 4 Digits"
              disabled={res?.ssn ? true : false}
              type="text"
              name="aadhar"
              className={`min-w-[100px] ${
                res?.ssn ? "bg-gray-100 cursor-not-allowed" : ""
              }`}
              value={res?.aadhar}
              onChange={(event: any) => {
                handleInputChange(index, "aadhar", event.target.value);
                handleError(index, "aadhar", event.target.value);
              }}
              isError={res?.aadhar_error}
              errorMessage={res?.aadhar_error}
            />
          </div>
        ),
      ssn:
        editIndex !== index ? (
          <Text text={res?.ssn || "-"} />
        ) : (
          <div>
            <CustomInput
              placeholder="Last 4 Digits"
              disabled={res?.aadhar ? true : false}
              type="text"
              name="ssn"
              className={`min-w-[100px] ${
                res?.aadhar ? "bg-gray-100 cursor-not-allowed" : ""
              }`}
              value={res?.ssn}
              onChange={(event: any) => {
                handleInputChange(index, "ssn", event.target.value);
                handleError(index, "ssn", event.target.value);
              }}
              isError={res?.ssn_error}
              errorMessage={res?.ssn_error}
            />
          </div>
        ),
      type:
        editIndex !== index ? (
          res?.type ? (
            "Manual"
          ) : (
            "Auto"
          )
        ) : (
          <SwitchComp
            resumeType={resumeType}
            setResumeType={setResumeType}
            index={index}
            on="Auto"
            off="Manual"
          />
        ),
      matching: (
        <Text text={`${((res?.having / res?.total) * 100 || 0).toFixed(0)}%`} />
      ),
      action: (
        <div className="flex items-center">
          {/* <IconButton
            icon={<MdModeEdit fontSize={18} />}
            onClick={() => {
              setEditIndex(index);
            }}
            disabled={editIndex === index}
          /> */}
          <IconButton
            onClick={() => removeResume(index)}
            icon={<MdDelete fontSize={18} />}
            color="red"
          />
        </div>
      ),
    }));

    return { columns, data };
  };

  const handleCloseModal = () => {
    setUploadResumeModal(false);
    setResumes([]);
    setResumeType([]);
    setEditIndex(null);
    setUploadStep(false);
  };

  const handleNext = () => {
    addresumes();
    setUploadStep(true);
  };

  const handleUpload = () => {
    uploadResume();
    setUploadStep(false);
  };

  const handleAddMoreFiles = () => {
    setUploadStep(false);
  };

  return (
    <Modal
      isOpen={uploadResumeModal}
      onClose={handleCloseModal}
      title="Upload Resume"
      size={"4xl"}
    >
      <div className=" flex flex-col mt-2 justify-between gap-4 ">
        <div className="grid grid-cols-3 gap-2 h-full">
          <div className="flex col-span-1 flex-col h-full">
            <div className="border rounded-lg h-full">
              <div className="flex w-full justify-between gap-1 p-3">
                <div
                  className={cn(
                    "flex w-[100%] flex-col space-y-3",
                    uploadStep ? "opacity-50 pointer-events-none w-[74%]" : ""
                  )}
                >
                  <div className="flex items-center  border border-primary rounded-lg overflow-hidden bg-white">
                    <div className="cursor-pointer ">
                      <label
                        className={`cursor-pointer w-full flex ${
                          uploadStep ? "opacity-50 pointer-events-none" : ""
                        }`}
                      >
                        <div className="flex justify-center gap-2 items-center border-r overflow-hidden font-semibold text-xs py-3 px-1 bg-primary text-white min-w-[75px]">
                          <BsUpload color="white" size={12} />{" "}
                          {selectedFile.length > 0 ? "Change" : "Upload"}
                        </div>
                        <div className="flex items-center w-full px-3">
                          {selectedFile.length !== 0 ? (
                            <div className="text-sm text-gray-600 truncate">
                              {selectedFile[0]?.name}
                            </div>
                          ) : (
                            <div className="text-sm text-gray-400">
                              Choose file...
                            </div>
                          )}
                          <input
                            type="file"
                            className="hidden"
                            multiple={true}
                            onChange={handleImageChange}
                            disabled={uploadStep}
                          />
                        </div>
                      </label>
                    </div>
                  </div>
                  {fileError ? (
                    <div className="error text-red-500 text-sm">
                      {fileError}
                    </div>
                  ) : (
                    <div className="text-[10px]  text-gray-500">
                      formats: .pdf, .docx; Maximum size: 3MB.
                    </div>
                  )}
                </div>

                {uploadStep && (
                  <Button
                    variant="outlined"
                    text="Add Files"
                    onClick={handleAddMoreFiles}
                    className="h-fit py-3 2xl:py-5"
                    disabled={!uploadStep}
                  />
                )}
              </div>
              {selectedFile.length > 0 && (
                <div className="overflow-hidden">
                  {/* Header */}
                  <div className=" px-4 ">
                    <div className="flex items-center border-b pb-2 border-gray-200 justify-between">
                      <p className="text-sm font-semibold text-gray-900">
                        Selected Files
                      </p>
                      <span className="inline-flex items-center justify-center px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">
                        {selectedFile.length} files
                      </span>
                    </div>
                  </div>

                  {/* Scrollable Files List */}
                  <div className="h-[calc(100vh-280px)] lg:h-[calc(100vh-280px)] xl:h-[calc(100vh-300px)] 2xl:h-[calc(100vh-410px)] overflow-y-auto">
                    {selectedFile.length === 0 ? (
                      <div className="flex flex-col items-center justify-center h-full text-gray-500">
                        <svg
                          className="w-12 h-12 mb-3 text-gray-300"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                          />
                        </svg>
                        <p className="text-sm">No files selected</p>
                      </div>
                    ) : (
                      selectedFile.map((resume: any, index: number) => (
                        <div
                          key={index}
                          className="flex items-center p-3 border-b border-gray-50 last:border-b-0 hover:bg-gray-50 transition-colors duration-150"
                        >
                          <div className="flex items-center gap-3 w-full">
                            {/* File Icon */}
                            <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-blue-50 rounded-lg">
                              <svg
                                className="w-4 h-4 text-blue-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                />
                              </svg>
                            </div>

                            {/* File Info and Controls */}
                            <div className="flex items-center justify-between flex-1 min-w-0">
                              <div className="min-w-0 flex-1">
                                <p className="text-sm font-medium text-gray-900 truncate">
                                  {resume.name}
                                </p>
                                <div className="flex items-center mt-1">
                                  <SwitchComp
                                    resumeType={resumeType}
                                    setResumeType={setResumeType}
                                    index={index}
                                    on={"Auto"}
                                    off={"Manual"}
                                  />
                                </div>
                              </div>

                              {/* Remove Button */}
                              <button
                                onClick={() => removeResume(index)}
                                type="button"
                                className="flex-shrink-0 ml-2 p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all duration-200"
                                disabled={uploadStep}
                                aria-label={`Remove ${resume.name}`}
                              >
                                <svg
                                  className="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}
              {selectedFile.length === 0 && (
                <div className="flex flex-col justify-center items-center gap-3 py-8">
                  <img
                    src={nodata}
                    alt="No resumes uploaded"
                    className="h-24 w-24 object-cover opacity-50"
                  />
                  <p className="text-sm text-gray-400">
                    No resumes uploaded yet.
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="flex col-span-2 flex-col h-full">
            <div className="border rounded-lg p-1 bg-gray-50 h-full">
              {resumes.length > 0 ? (
                <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
                  <Table
                    columns={getTableDetails().columns}
                    data={getTableDetails().data}
                    isStickyHeader
                    containerHeight="max-h-[65vh]"
                  />
                </div>
              ) : (
                <div className="flex flex-col justify-center items-center gap-3 py-12 h-full rounded-lg bg-white">
                  <div className="text-4xl text-gray-300">📄</div>
                  <p className="text-sm text-gray-400 text-center">
                    {uploadStep
                      ? "No resume data available"
                      : "Upload resumes and click Next to see details here"}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex flex-row justify-end gap-3 pt-2 border-t border-gray-200">
          <Button onClick={handleCloseModal} variant="outlined" text="Cancel" />
          {/* {selectedFile.length > 0 && !uploadStep && ( */}
          <Button
            text="Next"
            onClick={handleNext}
            disabled={selectedFile.length === 0 || uploadStep}
          />
          {/* )} */}
          {/* {uploadStep && ( */}
          <Button text="Upload" onClick={handleUpload} disabled={!uploadStep} />
          {/* )} */}
          {/* {uploadStep && selectedFile.length > 0 && (
            <div className="flex gap-2">
              <Button
                variant="outlined"
                text="Add More"
                onClick={handleAddMoreFiles}
              />
              <Button
                text="Upload All"
                onClick={handleUpload}
              />
            </div>
          )} */}
        </div>
      </div>
    </Modal>
  );
};

export { UploadCandidateResume };
